module.exports = __webpack_public_path__ + "img/cart.7b99f359.svg";